import {h, render} from 'preact';
import Page from '../components/Page';
import {defaultFaqPageSetting} from '@functions/const/defaultFaqPageSetting';
import ApiManager from '@scripttag/managers/ApiManager';
import logToConsole from '@scripttag/helpers/logToConsole';
import {prepareMetafields} from '@scripttag/helpers/faqHelpers';

/** @jsx h Tell babel to use h for JSX */
export default class DisplayManager {
  initialize() {
    logToConsole('Chatty page has initialized');

    this.display().then();
  }

  async display() {
    const {shopId} = window.AVADA_APP_FAQS_STATUS;
    const apiManager = new ApiManager();
    const getData = (path, params) => apiManager.getData(shopId, path, params);
    const putData = (path, data) => apiManager.putData(path, {...data, shopId});
    const postData = (path, data) => apiManager.postData(path, {...data, shopId});

    await prepareMetafields(postData);

    const {faqPageSetting: settings = defaultFaqPageSetting} = window.AVADA_FAQ || {};

    const {appCss} = settings;
    const container = document.querySelector('#AVADA_PAGE_FAQS');
    if (appCss) {
      const customCss = document.createElement('style');
      customCss.innerHTML = appCss;
      container.appendChild(customCss);
    }

    // const rootStyles = [
    //   'headerColor',
    //   'descriptionColor',
    //   'categoryColor',
    //   'questionTextColor',
    //   'questionBackgroundColor',
    //   'answerTextColor',
    //   'answerBackgroundColor'
    // ].map(field => `--${field}: ${settings[field]}`);

    // addRootStyles(container, rootStyles);

    render(<Page {...{getData, putData, postData}} />, container);
  }
}

// function addRootStyles(container, rootStyles) {
//   const id = 'chatty-root-styles';
//   const styleElem = document.querySelector('#' + id);
//   if (styleElem) {
//     styleElem.innerHTML = `:root {
//   ${rootStyles.join(';\n')}
// }`;
//     return;
//   }

//   const newElem = document.createElement('style');
//   newElem.id = id;
//   newElem.innerHTML = `:root {
//   ${rootStyles.join(';\n')}
// }`;
//   container.appendChild(newElem);
// }
